import { useCallback, useEffect, useState } from 'react'
import { StorageKeys } from '@/lib/storage/keys'
import {
  SOFT_BOOKMARKS_ENABLED_CHANGED_EVENT,
  getSoftBookmarksEnabled,
  setSoftBookmarksEnabled,
} from '@/lib/document-soft-bookmark'

export function useSoftBookmarksEnabled() {
  const [enabled, setEnabledState] = useState(getSoftBookmarksEnabled)

  useEffect(() => {
    const sync = () => setEnabledState(getSoftBookmarksEnabled())
    const onStorage = (event: StorageEvent) => {
      if (event.key === StorageKeys.EDITOR_SOFT_BOOKMARKS_ENABLED) sync()
    }
    window.addEventListener(SOFT_BOOKMARKS_ENABLED_CHANGED_EVENT, sync)
    window.addEventListener('storage', onStorage)
    return () => {
      window.removeEventListener(SOFT_BOOKMARKS_ENABLED_CHANGED_EVENT, sync)
      window.removeEventListener('storage', onStorage)
    }
  }, [])

  const setEnabled = useCallback((next: boolean) => {
    setSoftBookmarksEnabled(next)
  }, [])

  return { enabled, setEnabled }
}
